import type { TDatadogErrorLog } from 'utils/datadog/types'

export const GET_TERRITORY_SAVED_POST_TOTAL_POST_LOG: TDatadogErrorLog = {
  from: 'src/components/VideosTableCell/index.tsx',
  name: 'Get Territory Saved Post Total Post By Id',
  message: 'Failed to fetch territory saved post total posts for videos table cell',
}
